import React, {useContext, useEffect, useState} from 'react';
import {Avatar, Card, Chip, Tooltip} from "@mui/material";
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";
import {PAContext} from "../../../Services/PAContext";
import "./attendees.css";
import {cancelChipStyle} from "../../ButtonStyle/Cancel";
import {addChipStyle} from "../../ButtonStyle/Add";
import {addWaitGradientStyle} from "../../ButtonStyle/AddWait";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {formatName, stringAvatar, stringToColor} from "../../Helpers/TextStyling";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";



function AttendeesAddPrevious(props) {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account, SampleAttendees, authenticated } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);
    useEffect(() => {
        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);

    const [sortedAttendees, setSortedAttendees] = useState([]);
    const [selectedAttendees, setSelectedAttendees] = useState([]);

    useEffect(() => {
        // Sort the attendees by lname and then by fname for ties

        try {
            setSortedAttendees([...attendeesReferenceArray]
                .filter((_att) => {
                    return !PA_GlobalObject.Planning.attendees.some((planningAtt) => planningAtt.id === _att.id );
                })
                .sort((attendeeA, attendeeB) => {
                    const lnameA = (attendeeA.lname || '').toLowerCase(); // Use || '' for safety
                    const lnameB = (attendeeB.lname || '').toLowerCase();

                    // 1. Primary Sort: Compare Last Names
                    if (lnameA < lnameB) {
                        return -1;
                    }
                    if (lnameA > lnameB) {
                        return 1;
                    }

                    // 2. Secondary Sort (Tie-breaker): Last names are equal, compare First Names
                    const fnameA = (attendeeA.fname || '').toLowerCase();
                    const fnameB = (attendeeB.fname || '').toLowerCase();

                    if (fnameA < fnameB) {
                        return -1;
                    }
                    if (fnameA > fnameB) {
                        return 1;
                    }

                    // 3. Tertiary Sort: Names are identical
                    return 0;
                }));
        } catch (e){
            console.log(e);
        }

    }, [attendeesReferenceArray]);

    function toggleAttendeeSelection(attendee_id){
        console.log("Clicked on index : "+attendee_id);

        // Check if the attendee is already selected
        const isSelected = selectedAttendees.some((selected) => selected.id === attendee_id);

        console.log("Selected ? : "+isSelected);

        if (isSelected) {
            // If selected, remove from the selectedAttendees array
            setSelectedAttendees(selectedAttendees.filter((selected) => selected.id !== attendee_id));
        } else {
            // If not selected, add to the selectedAttendees array
            setSelectedAttendees([...selectedAttendees, sortedAttendees.find((_att) => _att.id === attendee_id)]);
        }

    }

    function handleAttendeesOK() {
        console.log("handleAttendeesOK");

        // Ensure selectedAttendees is not empty
        if (!selectedAttendees || selectedAttendees.length === 0) {
            console.log("No attendees selected.");
            return;
        }

        console.log("Selected Attendees: ", selectedAttendees);

        set_PA_GlobalObject((prev) => {
            // Ensure `Planning.attendees` exists
            const existingAttendees = prev.Planning?.attendees || [];

            // Find full attendee objects using selectedAttendees (which are just IDs)
            const selectedAttendeeIds = selectedAttendees.map(att => att.id); // Extract IDs

            const newAttendees = attendeesReferenceArray.filter(attendee =>
                selectedAttendeeIds.includes(attendee.id)
            );

            /*
                for each Attendee that we're adding they should have the role of 'guest'
                except if its the user that is logged in
                so go through the list and update the role
             */
            const updatedNewAttendees = newAttendees.map(attendee => ({
                ...attendee,
                role: attendee.id === Account.id ? 'admin' : 'guest'
            }));

            console.log("updatedNewAttendees : ", updatedNewAttendees);

            // Merge existing attendees while avoiding duplicates (based on attendee.id)
            const uniqueAttendees = [
                ...existingAttendees,
                ...updatedNewAttendees.filter(
                    newAttendee => !existingAttendees.some(existing => existing.id === newAttendee.id)
                ),
            ];

            console.log("uniqueAttendees : ", uniqueAttendees);


            // ✅ Ensure at least one attendee is an admin or master_admin
            const hasAdmin = uniqueAttendees.some(att =>
                att.role === 'admin' || att.role === 'master_admin'
            );

            if (!hasAdmin && uniqueAttendees.length > 0) {
                // Promote the first attendee to admin if none exists
                uniqueAttendees[0].role = 'admin';
            }

            return {
                Planning: {
                    ...prev.Planning, // Retain all existing fields in Planning
                    attendees: uniqueAttendees,
                },
            };
        });

        // 5. SERVER UPDATE
        if (authenticated && PA_GlobalObject.Planning.status !== 10) {
            sendSocketMessage({
                action: "E_addNewAttendeeFromPastEvents",
                event_id: PA_GlobalObject.Planning.id,
                addAttendees: selectedAttendees,
                send_welcome_message: false,
                welcome_message: "",
                rsvp_request: false
            });
        }

        // Navigate to the Attendees page
        navigate("/Planner/Attendees");
    }

    function handlePromptChangeAddPreviousClose() {
        navigate('/Planner/Attendees')
    }


    return (

        <div className="attendee-list-container" >
            {/* show the header */}
            <div
                className="attendee-list-header"
            >
                <div className="attendee-list-header-text">
                    <h5>Previous Attendees</h5>
                </div>
                <div className="attendee-list-header-chip-holder">
                    <Chip
                        sx={cancelChipStyle}
                        label="Cancel"
                        size="small"
                        color="error"
                        onClick={handlePromptChangeAddPreviousClose}
                    />
                    <Chip
                        sx={selectedAttendees.length===0 ? addWaitGradientStyle : addChipStyle}
                        label={selectedAttendees.length===0?'Add': 'Add '+selectedAttendees.length}
                        size="small"
                        onClick={selectedAttendees.length===0 ? undefined : handleAttendeesOK}
                    />
                </div>
            </div>


            {/* show the list of attendees */}
            <div
                className={
                    props.showingPageHeader
                        ? "attendee-list-items-container with-header"
                        : "attendee-list-items-container"
                }
            >
                <Grid container spacing={2} direction="column" sx={{flexWrap: 'nowrap'}}>

                    {
                        sortedAttendees.map((attendee, index) => (

                            <Card
                                key={index}
                                sx={{
                                    position: 'relative',
                                    display: 'flex',
                                    borderRadius: '5px',
                                    border: '1px solid #f09637',
                                    overflow: 'hidden',
                                    cursor: "pointer",
                                }}
                                onClick={() => toggleAttendeeSelection(attendee.id)}
                            >
                                {/* LEFT - Avatar Section */}
                                <Box
                                    sx={{
                                        width: '25%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#fafafa',
                                        padding: '5px 0'
                                    }}
                                >
                                    {!attendee.avatar?.preview ? (
                                        <Avatar
                                            {...stringAvatar(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}
                                            sx={{
                                                width: 60,
                                                height: 60,
                                                fontSize: '16px',
                                                color: '#000',
                                                backgroundColor: '#fff',
                                                border: `1px solid ${stringToColor(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}`,
                                                cursor: 'pointer',
                                            }}
                                        />
                                    ) : (
                                        <Avatar
                                            src={attendee.avatar.preview}
                                            sx={{
                                                width: 60,
                                                height: 60,
                                                border: `1px solid ${stringToColor(`${formatName(attendee.fname)}, ${formatName(attendee.lname)}`)}`,
                                                cursor: 'pointer',
                                            }}
                                        />
                                    )}
                                </Box>

                                <Box sx={{
                                    width: '75%',
                                    padding: '5px 5px 10px 5px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between'
                                }}>
                                    {/* Top: Name and Menu */}
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start'
                                    }}>
                                        <Box>
                                            <Typography variant="subtitle1">
                                                {formatName(attendee.lname)}, {formatName(attendee.fname)}
                                            </Typography>
                                            <Tooltip title={attendee.email} arrow>
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{
                                                        display: "block",
                                                        minWidth: 0,
                                                        maxWidth: "250px",  // Constrain subheader width
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow: "ellipsis",
                                                        flexShrink: 1, // Ensures email shrinks when necessary
                                                    }}
                                                >
                                                    {attendee.email}
                                                </Typography>
                                            </Tooltip>
                                        </Box>

                                        {
                                            selectedAttendees.some((selected) => selected.id === attendee.id) ? (
                                                <i className="icon-check attendee-list-item-add-item-checkmark"/>
                                            ) : (
                                                <i className="attendee-list-item-add-item-no-checkmark"/>
                                            )
                                        }

                                    </Box>

                                </Box>
                            </Card>
                        ))
                    }
                </Grid>
            </div>

        </div>

    )
}

export default AttendeesAddPrevious;
